import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { AuthProvider } from "./providers/AuthContext";
import { BrowserRouter as Router } from "react-router-dom";
import LoadingScreen from "./components/LoadingScreen.tsx";
import "./index.css"; // Import CSS at the top level to load immediately

// Render immediately without waiting for auth initialization
createRoot(document.getElementById("root")!).render(
  <LoadingScreen>
    <Router>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </LoadingScreen>
);

// Service Worker update detection
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.ready.then((reg) => {
      // Check for updates immediately
      reg.update();

      reg.addEventListener("updatefound", () => {
        const newWorker = reg.installing;
        if (newWorker) {
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // Dispatch custom event for update notification
              window.dispatchEvent(
                new CustomEvent("sw-update", {
                  detail: { registration: reg },
                })
              );
            }
          });
        }
      });

      // Also listen for controller change events
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.dispatchEvent(new CustomEvent("sw-update"));
      });
    });

    // Register periodic update checks (every 5 minutes)
    setInterval(
      () => {
        navigator.serviceWorker.ready.then((reg) => {
          reg.update();
        });
      },
      5 * 60 * 1000
    );
  });
}
